import React from 'react'
import styles from './LbDashboard.module.css'
import { FaTachometerAlt, FaGlobe, FaWpforms, FaChartBar, FaUsers, FaCogs, FaCreditCard, FaQuestionCircle } from 'react-icons/fa'
import LbDashboardOverview from '../../Components/LeadBridge/LbDashboard/LbDashboardOverview'
import LbDomainsManager from '../../Components/LeadBridge/LbDashboard/LbDomainsManager'
import LbFormsManager from '../../Components/LeadBridge/LbDashboard/LbFormsManager'
import LbAnalyticsPanel from '../../Components/LeadBridge/LbDashboard/LbAnalyticsPanel'
import LbActivityLogs from '../../Components/LeadBridge/LbDashboard/LbActivityLogs'
import LbEmbedCodeGenerator from '../../Components/LeadBridge/LbDashboard/LbEmbedCodeGenerator'
import LbCustomizations from '../../Components/LeadBridge/LbDashboard/LbCustomizations'
import LbTeamAccess from '../../Components/LeadBridge/LbDashboard/LbTeamAccess'
import LbPlanAndBilling from '../../Components/LeadBridge/LbDashboard/LbPlanAndBilling'
import LbSupportSection from '../../Components/LeadBridge/LbDashboard/LbSupportSection'
import { Link } from 'react-router'

const LbDashboard = ({ children }) => {
    return (
        <div className={styles.dashboardLayout}>
            {/* Sidebar */}
            {/* Main Content */}
            <div className={styles.mainContent}>
                <div className={styles.pageHeader}>
                    <Link to={`/leadbridge`} className={styles.phlWrapper}>
                        LeadBridge™
                    </Link>
                    <div className={styles.phrWrapper}>
                        <Link to={`/leadbridge/get-started/create-form`}>
                            Create Form
                        </Link>
                        <Link to={`/leadbridge/help`}>
                            Help
                        </Link>
                    </div>
                </div>

                <main className={styles.content}>
                    <div className={styles.leftCol}>
                        <LbDashboardOverview />
                        <LbFormsManager />
                        {/* <LbDomainsManager /> */}
                        {/* <LbCustomizations /> */}
                        {/* <LbTeamAccess /> */}
                        {/* <LbPlanAndBilling /> */}
                        {/* <LbSupportSection /> */}
                    </div>
                    <div className={styles.rightCol}>
                        <LbAnalyticsPanel />
                        {/* <LbActivityLogs /> */}
                        {/* <LbEmbedCodeGenerator /> */}
                    </div>

                </main>
            </div>
        </div>
    )
}

export default LbDashboard
